import * as React from 'react'
import { Vertical, SubVertical, MyMenu, MySubMenu } from 'common/constants'

export interface VerticalContextProps {
  vertical?: Vertical
  subVertical?: SubVertical
  pathname?: string
}

export const VerticalContext = React.createContext<VerticalContextProps>({
  vertical: null,
  subVertical: null,
  pathname: '/',
})

export interface MyMenuContextProps {
  myMenu?: MyMenu
  mySubMenu?: MySubMenu
  pathname?: string
}

export const MyContext = React.createContext<MyMenuContextProps>({
  myMenu: null,
  mySubMenu: null,
  pathname: '/',
})
